import React from "react";

interface ShieldLayer {
  readonly id: string;
  readonly size: number;
  readonly opacity: number;
  readonly strokeWidth: number;
  readonly animationDelay: string;
  readonly gradientId: string;
}

const SHIELD_LAYERS: readonly ShieldLayer[] = [
  {
    id: "shield-layer-outer",
    size: 292,
    opacity: 0.22,
    strokeWidth: 5,
    animationDelay: "0s",
    gradientId: "shieldGradientOuter",
  },
  {
    id: "shield-layer-mid",
    size: 236,
    opacity: 0.5,
    strokeWidth: 4.5,
    animationDelay: "0.35s",
    gradientId: "shieldGradientMid",
  },
  {
    id: "shield-layer-inner",
    size: 184,
    opacity: 0.5,
    strokeWidth: 5,
    animationDelay: "0.7s",
    gradientId: "shieldGradientInner",
  },
];

const SHIELD_PATH: string =
  "M100 14C130 30 160 40 188 46V96C188 144 160 185 100 220C40 185 12 144 12 96V46C40 40 70 30 100 14Z";

const ShieldInteractive = (): React.ReactElement => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        background: "#ffffff",
        transform: "scale(1.2)",
      }}
    >
      <style>
        {`
          @keyframes shieldPulse {
            0% {
              transform: translate(-50%, -50%) scale(0.985);
              opacity: 0.22;
              filter: drop-shadow(0 0 0 rgba(180, 207, 255, 0));
            }
            50% {
              transform: translate(-50%, -50%) scale(1.015);
              opacity: 0.62;
              filter: drop-shadow(0 8px 20px rgba(196, 220, 255, 0.18));
            }
            100% {
              transform: translate(-50%, -50%) scale(0.985);
              opacity: 0.22;
              filter: drop-shadow(0 0 0 rgba(180, 207, 255, 0));
            }
          }

          @keyframes shieldCorePulse {
            0% {
              transform: translate(-50%, -50%) scale(0.99);
              box-shadow: 0 0 0 0 rgba(196, 221, 255, 0.2);
            }
            50% {
              transform: translate(-50%, -50%) scale(1.03);
              box-shadow: 0 0 0 12px rgba(196, 221, 255, 0);
            }
            100% {
              transform: translate(-50%, -50%) scale(0.99);
              box-shadow: 0 0 0 0 rgba(196, 221, 255, 0);
            }
          }
        `}
      </style>

      {SHIELD_LAYERS.map(
        (layer: ShieldLayer): React.ReactElement => (
          <svg
            key={layer.id}
            viewBox="0 0 200 240"
            aria-hidden="true"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: layer.size,
              height: layer.size,
              overflow: "visible",
              transform: "translate(-50%, -50%)",
              opacity: layer.opacity,
              animation: `shieldPulse 2.8s ease-in-out infinite`,
              animationDelay: layer.animationDelay,
            }}
          >
            <defs>
              <linearGradient
                id={layer.gradientId}
                x1="18"
                y1="22"
                x2="180"
                y2="220"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0%" stopColor="#edf5ff" />
                <stop offset="48%" stopColor="#d4e6ff" />
                <stop offset="100%" stopColor="#bfd8ff" />
              </linearGradient>
            </defs>
            <path
              d={SHIELD_PATH}
              fill="none"
              stroke={`url(#${layer.gradientId})`}
              strokeWidth={layer.strokeWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )
      )}

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: 110,
          height: 110,
          transform: "translate(-50%, -50%)",
          clipPath:
            "polygon(50% 5%, 86% 20%, 86% 48%, 80% 67%, 68% 84%, 50% 98%, 32% 84%, 20% 67%, 14% 48%, 14% 20%)",
          background:
            "linear-gradient(180deg, rgba(250,253,255,1) 0%, rgba(238,246,255,0.98) 52%, rgba(224,237,255,0.96) 100%)",
          border: "1px solid rgba(221, 235, 255, 0.9)",
          boxShadow:
            "0 10px 22px rgba(202, 220, 246, 0.22), inset 0 1px 0 rgba(255,255,255,0.95)",
          animation: "shieldCorePulse 2.8s ease-in-out infinite",
        }}
      />

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: 64,
          height: 64,
          transform: "translate(-50%, -50%)",
          clipPath:
            "polygon(50% 6%, 84% 21%, 84% 46%, 79% 62%, 66% 81%, 50% 94%, 34% 81%, 21% 62%, 16% 46%, 16% 21%)",
          background:
            "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(243,248,255,0.98) 100%)",
          boxShadow:
            "inset 0 1px 0 rgba(255,255,255,0.98), 0 4px 12px rgba(208, 223, 245, 0.16)",
        }}
      />
    </div>
  );
};

export default ShieldInteractive;



